import { render, staticRenderFns } from "./PortDetail.vue?vue&type=template&id=aea0fdf6&scoped=true&"
import script from "./PortDetail.vue?vue&type=script&lang=js&"
export * from "./PortDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea0fdf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aea0fdf6')) {
      api.createRecord('aea0fdf6', component.options)
    } else {
      api.reload('aea0fdf6', component.options)
    }
    module.hot.accept("./PortDetail.vue?vue&type=template&id=aea0fdf6&scoped=true&", function () {
      api.rerender('aea0fdf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/port/PortDetail.vue"
export default component.exports